const types = {
    SET_RX_RENEWAL_CASE_COUNT_LOADING: 'SET_RX_RENEWAL_CASE_COUNT_LOADING',
    SET_RX_RENEWAL_CASE_COUNT: 'SET_RX_RENEWAL_CASE_COUNT',
};

export default types;